import React from "react";

const PERSON_TYPES = [
  { value: "", label: "All types" },
  { value: "employee", label: "Employee" },
  { value: "contractor", label: "Contractor" },
  { value: "freelancer", label: "Freelancer" },
  { value: "intern", label: "Intern" },
  { value: "consultant", label: "Consultant" },
  { value: "external_partner", label: "External partner" },
  { value: "former_employee", label: "Former employee" },
  { value: "candidate", label: "Candidate" },
];

const STATUSES = [
  { value: "", label: "All statuses" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "archived", label: "Archived" },
];

export default function HRPeopleFilters({
  filters,
  onChange,
  onReset,
  departments = [],
  teams = [],
  positions = [],
}) {
  function updateField(key, value) {
    onChange?.({ ...filters, [key]: value });
  }

  return (
    <div className="bg-white dark:bg-neutral-900 rounded-2xl border border-gray-200 dark:border-neutral-700 shadow-sm p-4">
      <div className="flex flex-col xl:flex-row xl:items-end gap-4">
        <div className="flex-1">
          <label className="block text-sm font-medium mb-2">Search</label>
          <input
            className="w-full border border-gray-300 dark:border-neutral-700 rounded-xl px-3 py-2 bg-white dark:bg-neutral-950"
            placeholder="Name, email, employee code..."
            value={filters.q || ""}
            onChange={(e) => updateField("q", e.target.value)}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-3 flex-[2]">
          <div>
            <label className="block text-sm font-medium mb-2">Status</label>
            <select
              className="w-full border border-gray-300 dark:border-neutral-700 rounded-xl px-3 py-2 bg-white dark:bg-neutral-950"
              value={filters.status || ""}
              onChange={(e) => updateField("status", e.target.value)}
            >
              {STATUSES.map((item) => (
                <option key={item.value || "all-status"} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Type</label>
            <select
              className="w-full border border-gray-300 dark:border-neutral-700 rounded-xl px-3 py-2 bg-white dark:bg-neutral-950"
              value={filters.person_type || ""}
              onChange={(e) => updateField("person_type", e.target.value)}
            >
              {PERSON_TYPES.map((item) => (
                <option key={item.value || "all-types"} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Department</label>
            <select
              className="w-full border border-gray-300 dark:border-neutral-700 rounded-xl px-3 py-2 bg-white dark:bg-neutral-950"
              value={filters.department_id || ""}
              onChange={(e) => updateField("department_id", e.target.value)}
            >
              <option value="">All departments</option>
              {departments.map((d) => (
                <option key={d.id} value={d.id}>
                  {d.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Team</label>
            <select
              className="w-full border border-gray-300 dark:border-neutral-700 rounded-xl px-3 py-2 bg-white dark:bg-neutral-950"
              value={filters.team_id || ""}
              onChange={(e) => updateField("team_id", e.target.value)}
            >
              <option value="">All teams</option>
              {teams.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Position</label>
            <select
              className="w-full border border-gray-300 dark:border-neutral-700 rounded-xl px-3 py-2 bg-white dark:bg-neutral-950"
              value={filters.position_id || ""}
              onChange={(e) => updateField("position_id", e.target.value)}
            >
              <option value="">All positions</option>
              {positions.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.title}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex gap-2">
          <button
            type="button"
            onClick={onReset}
            className="px-4 py-2 rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-950"
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  );
}